import { type IntegrationServiceId } from './integrations'
import { type User } from '../models/User'
import { type Account, getAccountDocumentIntegrationConfig } from '../models/Account'

export const getLinkedFolderIds = (contact: User, serviceId?: IntegrationServiceId): string[] =>
  !serviceId ? [] : (contact.integrations?.filter((i) => i.type === 'document' && i.serviceId === serviceId).map((i) => i.externalId) ?? [])

export const getAccountLinkedFolderId = (account: Account | undefined, serviceId?: IntegrationServiceId): string | undefined =>
  !serviceId ? undefined : (getAccountDocumentIntegrationConfig(serviceId, account)?.externalId ?? undefined)

export const getDistinctLinkedFolderIds = (contacts: User[], serviceId?: IntegrationServiceId): string[] | null => {
  if (!serviceId) {
    return null
  }
  const ids = new Set(contacts.flatMap((contact) => getLinkedFolderIds(contact, serviceId)))
  return ids.size > 0 ? [...ids] : null
}
